import pieChartScanValidity from './pie-chart-scan-validity.container';

export default pieChartScanValidity;
